// import React, { useEffect, useState } from "react";
// import Layouts from "../../Layouts";
// import { Breadcrumb, Input } from "antd";
// import { TbTruckDelivery } from "react-icons/tb";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   setAddItemToCart,
//   setIncreaseItemQTY,
//   setDecreaseItemQTY,
//   setRemoveItemFromCart,
// } from "../../../app/CartSlice";
// import { useParams, useNavigate } from "react-router-dom";
// import ProductService from "../../../Redux/Services/ProductService";
// import {
//   PlusOutlined,
//   MinusOutlined,
//   ShoppingCartOutlined,
//   DeleteOutlined,
//   CheckCircleFilled,
// } from "@ant-design/icons";

// function Productdetail() {
//   const [activeTab, setActiveTab] = useState("description");
//   const [selectedSize, setSelectedSize] = useState(null);
//   const [selectedProductPrice, setSelectedProductPrice] = useState(0);
//   const [selectedProductMrp, setSelectedProductMrp] = useState(0);
//   const [selectedDiscount, setSelectedDiscount] = useState(0);
//   const [currIdx, setCurrIdx] = useState(0);
//   const { id } = useParams();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [currItem, setCurrItem] = useState(null);
//   const [currProdDetInfo, setCurrProdDetInfo] = useState([]);
//   const [currProduct, setCurrProduct] = useState([]);

//   // Subscribe to cart items
//   const cartItems = useSelector((state) => state.cart?.cartItems) || [];

//   const ProductListData = async () => {
//     try {
//       const payload = { status: 1, id };
//       const result = await ProductService.ProductList(payload);
//       if (result?.data && result.data.length > 0) {
//         setCurrItem(result.data[0]);
//         const inventoryPayload = {
//           // status: 1,
//           productCode: result.data[0].code
//         };
//         const inventoryRes = await ProductService.productInvetoryData(inventoryPayload);
//         setCurrProdDetInfo(inventoryRes.data || []);
//       }
//     } catch (err) {
//       console.error("Error fetching product data:", err);
//     }
//   };

//   const fetProductDetails = async (code) => {
//     if (code) {
//       try {
//         const response = await ProductService.productInvetoryData({ productCode: code });
//         setCurrProduct(response.data || []);
//       } catch (err) {
//         console.error("Error fetching product inventory:", err);
//       }
//     }
//   };

//   useEffect(() => {
//     if (currItem && currItem.productPackageDetails && currItem.productPackageDetails.length > 0) {
//       const defaultSize = currItem.productPackageDetails[0];
//       handleSize(defaultSize, 0);

//       const selectedProduct = currProdDetInfo?.find(
//         (item) => item.packageCode === defaultSize.packageSize
//       );

//       if (selectedProduct) {
//         setSelectedProductMrp(selectedProduct.unitPrice);
//         setSelectedProductPrice(selectedProduct.finalPrice);
//         setSelectedDiscount(selectedProduct.discountPercentage || 0);
//       }
//     }
//   }, [currProdDetInfo, currItem]);

//   useEffect(() => {
//     ProductListData();
//     fetProductDetails();
//   }, [id]);

//   const handleSize = (size, idx) => {
//     setSelectedSize(size);
//     setCurrIdx(idx);
//     const sizeName = typeof size === "object" ? size.packageSize : size;
//     const selected = currProdDetInfo?.find((item) => item.packageCode === sizeName);
//     if (selected) {
//       setSelectedProductMrp(selected.unitPrice);
//       setSelectedProductPrice(selected.finalPrice);
//       setSelectedDiscount(selected.discountPercentage || 0);
//     }
//   };

//   // Find quantity for current size variant in cart
//   const currentSizeKey =
//     typeof selectedSize === "object" && selectedSize?.packageSize
//       ? String(selectedSize.packageSize).trim().toLowerCase()
//       : String(selectedSize || "standard").trim().toLowerCase();

//   const cartItem = cartItems.find((item) => {
//     const itemSizeKey =
//       typeof item.selectedSize === "object" && item.selectedSize?.packageSize
//         ? String(item.selectedSize.packageSize).trim().toLowerCase()
//         : String(item.selectedSize || "standard").trim().toLowerCase();
//     return (item.id === currItem?.id || item.code === currItem?.code) && itemSizeKey === currentSizeKey;
//   });

//   const cartQuantity = cartItem ? Number(cartItem.cartQuantity) || 0 : 0;

//   const handleAddToCart = () => {
//     let priceToUse = selectedProductPrice;
//     if (!priceToUse && currProdDetInfo && currProdDetInfo.length > 0) {
//       const sizeName = typeof selectedSize === "object" ? selectedSize?.packageSize : selectedSize;
//       const selected = currProdDetInfo.find((item) => item.packageCode === sizeName);
//       if (selected) {
//         priceToUse = selected.finalPrice || selected.unitPrice;
//       } else if (currProdDetInfo[0]) {
//         priceToUse = currProdDetInfo[0].finalPrice || currProdDetInfo[0].unitPrice;
//       }
//     }
//     const numericPrice = Number(priceToUse || selectedProductMrp || 0);
//     const sizeToUse =
//       selectedSize ||
//       (currItem?.productPackageDetails && currItem.productPackageDetails[0]) || {
//         packageSize: "Standard",
//       };

//     const itemTobeAdded = {
//       ...currItem,
//       selectedProductPrice: numericPrice,
//       price: numericPrice,
//       selectedSize: sizeToUse,
//     };
//     dispatch(setAddItemToCart(itemTobeAdded));
//   };

//   const handleIncrement = () => {
//     if (cartItem) {
//       dispatch(setIncreaseItemQTY(cartItem.cartItemId || cartItem.id));
//     }
//   };

//   const handleDecrement = () => {
//     if (cartItem) {
//       if (cartQuantity > 1) {
//         dispatch(setDecreaseItemQTY(cartItem.cartItemId || cartItem.id));
//       } else {
//         dispatch(setRemoveItemFromCart(cartItem));
//       }
//     }
//   };

//   const handleBuyNow = () => {
//     if (cartQuantity === 0) {
//       handleAddToCart();
//     }
//     navigate("/cart");
//   };

//   const handleTabClick = (tabNumber) => {
//     setActiveTab(tabNumber);
//   };

//   const imageSrc = currItem?.imageName
//     ? currItem.imageName.startsWith("http") || currItem.imageName.startsWith("data:")
//       ? currItem.imageName
//       : `${process.env.REACT_APP_IMAGE_URL || ""}${currItem.imageName}`
//     : currItem?.imageUrl || "";

//   return (
//     <Layouts>
//       <div className="container mx-auto px-4 md:px-8">
//         <div className="bg-white rounded-2xl shadow-sm border border-amber-100/60 p-4 md:p-8 mt-6">
//           <div className="mb-6">
//             <Breadcrumb
//               separator=">"
//               items={[
//                 { title: "Home", href: "/" },
//                 { title: "Products", href: "/product" },
//                 { title: currItem?.name || "Product Details" },
//               ]}
//             />
//           </div>

//           <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
//             {/* Left: Product Images */}
//             <div className="flex flex-col-reverse md:flex-row gap-4 items-center md:items-start">
//               {/* Thumbnails */}
//               <div className="flex md:flex-col gap-2 ">
//                 {[1, 2, 3, 4].map((_, i) => (
//                   <div
//                     key={i}
//                     className="border-2 border-amber-200/80 hover:border-[#A17A17] rounded-xl w-16 h-16 md:w-20 md:h-20 flex justify-center items-center p-1 bg-amber-50/20 cursor-pointer transition-all"
//                   >
//                     <img src={imageSrc} alt="" className="max-h-full max-w-full object-contain" />
//                   </div>
//                 ))}
//               </div>

//               {/* Main Image Display */}
//               <div className="w-full border border-amber-100 rounded-2xl flex items-center justify-center h-[340px] md:h-[420px] bg-gradient-to-b from-[#FFFDF9] to-white p-6 relative">
//                 {selectedDiscount > 0 && (
//                   <div className="absolute top-4 left-4 bg-gradient-to-r from-amber-600 to-amber-500 text-white font-bold text-xs py-1 px-3.5 rounded-full shadow-md">
//                     {selectedDiscount}% OFF
//                   </div>
//                 )}
//                 <img
//                   className="max-h-[300px] md:max-h-[360px] max-w-full object-contain drop-shadow-md hover:scale-105 transition-transform duration-300"
//                   src={imageSrc}
//                   alt={currItem?.name}
//                 />
//               </div>
//             </div>

//             {/* Right: Product Details & Controls */}
//             <div className="flex flex-col justify-between">
//               <div>
//                 <h1 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight">
//                   {currItem?.name}
//                 </h1>

//                 {/* Pricing Display */}
//                 <div className="flex items-baseline gap-3 mt-4">
//                   {selectedProductMrp > selectedProductPrice && (
//                     <span className="line-through text-gray-400 text-base font-medium">
//                       INR {selectedProductMrp}
//                     </span>
//                   )}
//                   <span className="text-3xl font-black text-[#A17A17]">
//                     INR {selectedProductPrice || selectedProductMrp || 0}
//                   </span>
//                   <span className="text-xs text-green-700 bg-green-50 px-2 py-0.5 rounded-md font-medium">
//                     Inclusive of all taxes
//                   </span>
//                 </div>

//                 <hr className="my-5 border-gray-100" />

//                 {/* Package Size Selector */}
//                 <div>
//                   <p className="text-xs uppercase font-semibold tracking-wider text-gray-500 mb-2.5">
//                     Select Package Size
//                   </p>
//                   <div className="flex flex-wrap gap-2.5 w-full">
//                     {currItem?.productPackageDetails?.map((size, idx) => {
//                       const isSelected =
//                         (selectedSize === size ||
//                           (selectedSize?.packageSize && selectedSize.packageSize === size.packageSize)) &&
//                         currIdx === idx;
//                       return (
//                         <button
//                           key={idx}
//                           type="button"
//                           className={`px-5 py-2 rounded-xl text-sm font-semibold transition-all duration-200 cursor-pointer ${isSelected
//                               ? "bg-[#A17A17] text-white shadow-md border-2 border-[#A17A17] scale-102"
//                               : "bg-[#FAF3E0]/70 text-gray-700 hover:bg-[#FAF3E0] border-2 border-amber-200/80"
//                             }`}
//                           onClick={() => handleSize(size, idx)}
//                         >
//                           {size.packageSize}
//                         </button>
//                       );
//                     })}
//                   </div>
//                 </div>

//                 {/* Action Buttons / Interactive Quantity Controller */}
//                 <div className="mt-8">
//                   {cartQuantity === 0 ? (
//                     <div className="flex flex-col sm:flex-row gap-3 items-center">
//                       <button
//                         className="w-full sm:w-52 h-12 rounded-xl bg-gradient-to-r from-[#A17A17] to-[#B88E28] hover:from-[#8C6913] hover:to-[#A17A17] text-white text-base font-bold shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 active:scale-98 cursor-pointer"
//                         onClick={handleAddToCart}
//                       >
//                         <ShoppingCartOutlined className="text-lg" />
//                         <span>Add To Cart</span>
//                       </button>
//                       <button
//                         className="w-full sm:w-52 h-12 rounded-xl border-2 border-[#A17A17] text-[#A17A17] hover:bg-[#FAF3E0] text-base font-bold transition-all duration-200 flex items-center justify-center cursor-pointer active:scale-98"
//                         onClick={handleBuyNow}
//                       >
//                         Buy Now
//                       </button>
//                     </div>
//                   ) : (
//                     <div className="flex flex-col sm:flex-row gap-3 items-center">
//                       {/* Interactive Counter Controller */}
//                       <div className="w-full sm:w-52 h-12 bg-[#FFF8E7] border-2 border-[#A17A17] rounded-xl flex items-center justify-between px-3 shadow-inner">
//                         <button
//                           type="button"
//                           onClick={handleDecrement}
//                           className="w-9 h-9 rounded-lg bg-[#A17A17] hover:bg-[#8C6913] text-white flex items-center justify-center transition-all duration-150 active:scale-90 shadow cursor-pointer"
//                           title={cartQuantity === 1 ? "Remove from cart" : "Decrease quantity"}
//                         >
//                           {cartQuantity === 1 ? (
//                             <DeleteOutlined className="text-sm" />
//                           ) : (
//                             <MinusOutlined className="text-sm" />
//                           )}
//                         </button>

//                         <div className="flex flex-col items-center justify-center select-none px-2">
//                           <span className="text-lg font-black text-[#4C3000] leading-none">
//                             {cartQuantity}
//                           </span>
//                           <span className="text-[10px] text-amber-900 font-semibold leading-none mt-0.5">
//                             in cart
//                           </span>
//                         </div>

//                         <button
//                           type="button"
//                           onClick={handleIncrement}
//                           className="w-9 h-9 rounded-lg bg-[#A17A17] hover:bg-[#8C6913] text-white flex items-center justify-center transition-all duration-150 active:scale-90 shadow cursor-pointer"
//                           title="Increase quantity"
//                         >
//                           <PlusOutlined className="text-sm" />
//                         </button>
//                       </div>

//                       <button
//                         className="w-full sm:w-52 h-12 rounded-xl bg-[#A17A17] hover:bg-[#8C6913] text-white text-base font-bold shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer active:scale-98"
//                         onClick={() => navigate("/cart")}
//                       >
//                         <span>Go to Cart</span>
//                         <CheckCircleFilled className="text-amber-200" />
//                       </button>
//                     </div>
//                   )}
//                 </div>

//                 {/* Delivery Checker */}
//                 <div className="mt-8 p-4 bg-amber-50/40 rounded-xl border border-amber-100">
//                   <div className="flex gap-2 items-center text-gray-700 font-medium mb-2">
//                     <TbTruckDelivery className="text-xl text-[#A17A17]" />
//                     <span className="text-xs uppercase tracking-wider font-bold text-gray-600">
//                       Check Delivery Availability
//                     </span>
//                   </div>
//                   <div className="flex gap-2 items-center">
//                     <Input
//                       className="rounded-lg h-10 w-48 border-amber-200 focus:border-[#A17A17]"
//                       placeholder="Enter 6-digit pin code"
//                       maxLength={6}
//                     />
//                     <button className="h-10 px-5 bg-[#A17A17] hover:bg-[#8C6913] text-white text-sm font-medium rounded-lg transition-colors cursor-pointer">
//                       Check
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Product Information Tabs */}
//         <div className="mt-8 bg-white rounded-2xl shadow-sm border border-amber-100/60 overflow-hidden">
//           <div className="flex flex-wrap md:flex-nowrap justify-center gap-2 md:gap-8 bg-[#FFF8E7] border-b border-amber-200/60 p-2">
//             {[
//               { key: "description", label: "DESCRIPTION" },
//               { key: "howtouse", label: "HOW TO USE" },
//               { key: "ingredients", label: "INGREDIENTS" },
//               { key: "benefits", label: "BENEFITS" },
//             ].map((tab) => (
//               <button
//                 key={tab.key}
//                 onClick={() => handleTabClick(tab.key)}
//                 className={`py-2.5 px-4 text-sm md:text-base font-bold transition-all rounded-lg cursor-pointer ${activeTab === tab.key
//                     ? "text-[#A17A17] bg-white shadow-sm border border-amber-200/80"
//                     : "text-gray-600 hover:text-[#A17A17]"
//                   }`}
//               >
//                 {tab.label}
//               </button>
//             ))}
//           </div>

//           <div className="p-6 md:p-8 text-gray-700 leading-relaxed">
//             {activeTab === "description" && (
//               <div>
//                 <h3 className="font-bold text-lg text-gray-900 mb-3">Product Overview</h3>
//                 <p className="text-base text-gray-600 whitespace-pre-line">
//                   {currItem?.description || "No description provided for this product."}
//                 </p>
//               </div>
//             )}

//             {activeTab === "howtouse" && (
//               <div>
//                 <h3 className="font-bold text-lg text-gray-900 mb-3">Usage Instructions</h3>
//                 {currItem?.productToUse && currItem.productToUse.length > 0 ? (
//                   <ul className="list-disc list-inside space-y-2 text-base text-gray-600">
//                     {currItem.productToUse.map((item, i) => (
//                       <li key={i}>{item.description}</li>
//                     ))}
//                   </ul>
//                 ) : (
//                   <p className="text-gray-500">As directed by your Ayurvedic physician.</p>
//                 )}
//               </div>
//             )}

//             {activeTab === "ingredients" && (
//               <div>
//                 <h3 className="font-bold text-lg text-gray-900 mb-3">Key Ingredients</h3>
//                 {currItem?.productIngredients && currItem.productIngredients.length > 0 ? (
//                   <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3">
//                     {currItem.productIngredients.map((item, i) => (
//                       <div key={i} className="p-3 bg-amber-50/50 border border-amber-100 rounded-xl font-medium text-gray-800">
//                         🌿 {item.ingredientName}
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <p className="text-gray-500">Authentic herbs formulated according to traditional texts.</p>
//                 )}
//               </div>
//             )}

//             {activeTab === "benefits" && (
//               <div>
//                 <h3 className="font-bold text-lg text-gray-900 mb-3">Health Benefits</h3>
//                 {currItem?.productBenfits && currItem.productBenfits.length > 0 ? (
//                   <ul className="list-disc list-inside space-y-2 text-base text-gray-600">
//                     {currItem.productBenfits.map((item, i) => (
//                       <li key={i}>{item.benfitDetails}</li>
//                     ))}
//                   </ul>
//                 ) : (
//                   <p className="text-gray-500">Promotes holistic wellness and balance.</p>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </Layouts>
//   );
// }

// export default Productdetail;

import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import { Breadcrumb, Input, message } from "antd";
import { TbTruckDelivery } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCartDb,
  increaseQtyDb,
  decreaseQtyDb,
  removeItemDb,
} from "../../../app/CartSlice";
import { isAuthenticated } from "../../../utils/auth";
import { useParams, useNavigate } from "react-router-dom";
import ProductService from "../../../Redux/Services/ProductService";
import {
  PlusOutlined,
  MinusOutlined,
  ShoppingCartOutlined,
  DeleteOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";

function Productdetail() {
  const [activeTab, setActiveTab] = useState("description");
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedProductPrice, setSelectedProductPrice] = useState(0);
  const [selectedProductMrp, setSelectedProductMrp] = useState(0);
  const [selectedDiscount, setSelectedDiscount] = useState(0);
  const [currIdx, setCurrIdx] = useState(0);

  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [currItem, setCurrItem] = useState(null);
  const [currProdDetInfo, setCurrProdDetInfo] = useState([]);
  const [deliveryPin, setDeliveryPin] = useState("");
  // zoom product image
  const [isImageHovered, setIsImageHovered] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({
    x: 50,
    y: 50,
  });

  const cartItems = useSelector((state) => state.cart?.cartItems) || [];

  // zoom image handlers
  const handleImageMouseMove = (e) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();

    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setZoomPosition({
      x: Math.max(0, Math.min(100, x)),
      y: Math.max(0, Math.min(100, y)),
    });
  };
  // ============================================================
  // GET PRODUCT DETAILS
  // ============================================================
  const ProductListData = async () => {
    try {
      const payload = {
        status: 1,
        id,
      };

      const result = await ProductService.ProductList(payload);

      if (result?.data && result.data.length > 0) {
        const product = result.data[0];

        setCurrItem(product);

        const inventoryPayload = {
          productCode: product.code,
        };

        const inventoryRes =
          await ProductService.productInvetoryData(inventoryPayload);

        setCurrProdDetInfo(inventoryRes.data || []);
      }
    } catch (err) {
      console.error("Error fetching product data:", err);
    }
  };

  // ============================================================
  // LOAD PRODUCT INVENTORY
  // ============================================================
  useEffect(() => {
    ProductListData();
  }, [id]);

  // ============================================================
  // SET DEFAULT PACKAGE
  // ============================================================
  useEffect(() => {
    if (
      currItem?.productPackageDetails &&
      currItem.productPackageDetails.length > 0 &&
      currProdDetInfo.length > 0
    ) {
      const defaultSize = currItem.productPackageDetails[0];

      setSelectedSize(defaultSize);
      setCurrIdx(0);

      const selectedProduct = currProdDetInfo.find(
        (item) => item.packageCode === defaultSize.packageSize
      );

      if (selectedProduct) {
        setSelectedProductMrp(Number(selectedProduct.unitPrice || 0));
        setSelectedProductPrice(Number(selectedProduct.finalPrice || 0));
        setSelectedDiscount(
          Number(selectedProduct.discountPercentage || 0)
        );
      }
    }
  }, [currItem, currProdDetInfo]);

  // ============================================================
  // SELECT PACKAGE SIZE
  // ============================================================
  const handleSize = (size, idx) => {
    setSelectedSize(size);
    setCurrIdx(idx);

    const sizeName =
      typeof size === "object" ? size?.packageSize : size;

    const selected = currProdDetInfo?.find(
      (item) => item.packageCode === sizeName
    );

    if (selected) {
      setSelectedProductMrp(Number(selected.unitPrice || 0));
      setSelectedProductPrice(Number(selected.finalPrice || 0));
      setSelectedDiscount(
        Number(selected.discountPercentage || 0)
      );
    }
  };

  // ============================================================
  // CART ITEM
  // ============================================================
  const currentSizeKey =
    typeof selectedSize === "object" && selectedSize?.packageSize
      ? String(selectedSize.packageSize).trim().toLowerCase()
      : String(selectedSize || "standard")
        .trim()
        .toLowerCase();

  const cartItem = cartItems.find((item) => {
    const itemSizeKey =
      typeof item.selectedSize === "object" &&
        item.selectedSize?.packageSize
        ? String(item.selectedSize.packageSize)
          .trim()
          .toLowerCase()
        : String(item.selectedSize || "standard")
          .trim()
          .toLowerCase();

    return (
      (item.id === currItem?.id || item.code === currItem?.code) &&
      itemSizeKey === currentSizeKey
    );
  });

  const cartQuantity = cartItem
    ? Number(cartItem.cartQuantity) || 0
    : 0;

  // ============================================================
  // ADD TO CART
  // ============================================================
  const handleAddToCart = () => {
    if (!isAuthenticated()) {
      message.warning("Please log in to add items to your cart.");
      window.dispatchEvent(new Event("openLoginModal"));
      return;
    }

    let priceToUse = selectedProductPrice;

    if (
      !priceToUse &&
      currProdDetInfo &&
      currProdDetInfo.length > 0
    ) {
      const sizeName =
        typeof selectedSize === "object"
          ? selectedSize?.packageSize
          : selectedSize;

      const selected = currProdDetInfo.find(
        (item) => item.packageCode === sizeName
      );

      if (selected) {
        priceToUse =
          selected.finalPrice || selected.unitPrice;
      } else if (currProdDetInfo[0]) {
        priceToUse =
          currProdDetInfo[0].finalPrice ||
          currProdDetInfo[0].unitPrice;
      }
    }

    const numericPrice = Number(
      priceToUse || selectedProductMrp || 0
    );

    const sizeToUse =
      selectedSize ||
      currItem?.productPackageDetails?.[0] || {
        packageSize: "Standard",
      };

    const itemTobeAdded = {
      ...currItem,
      selectedProductPrice: numericPrice,
      price: numericPrice,
      selectedSize: sizeToUse,
    };

    dispatch(addToCartDb(itemTobeAdded));
  };

  // ============================================================
  // INCREMENT
  // ============================================================
  const handleIncrement = () => {
    if (!isAuthenticated()) {
      message.warning("Please log in to manage your cart.");
      window.dispatchEvent(new Event("openLoginModal"));
      return;
    }

    if (cartItem) {
      dispatch(
        increaseQtyDb(
          cartItem.cartItemId || cartItem.id
        )
      );
    }
  };

  // ============================================================
  // DECREMENT
  // ============================================================
  const handleDecrement = () => {
    if (!isAuthenticated()) {
      message.warning("Please log in to manage your cart.");
      window.dispatchEvent(new Event("openLoginModal"));
      return;
    }

    if (cartItem) {
      if (cartQuantity > 1) {
        dispatch(
          decreaseQtyDb(cartItem)
        );
      } else {
        dispatch(removeItemDb(cartItem));
      }
    }
  };

  // ============================================================
  // BUY NOW
  // ============================================================
  const handleBuyNow = () => {
    if (cartQuantity === 0) {
      handleAddToCart();
    }

    navigate("/cart");
  };

  // ============================================================
  // IMAGE
  // ============================================================
  const imageSrc = currItem?.imageName
    ? currItem.imageName.startsWith("http") ||
      currItem.imageName.startsWith("data:")
      ? currItem.imageName
      : `${process.env.REACT_APP_IMAGE_URL || ""}${currItem.imageName}`
    : currItem?.imageUrl || "";

  // ============================================================
  // TAB
  // ============================================================
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <Layouts>
      <div className="min-h-screen bg-[#FAF8F5]">

        {/* ======================================================
            MAIN CONTAINER
        ====================================================== */}
        <div className="w-full max-w-7xl mx-auto px-3 sm:px-5 md:px-8 lg:px-10">

          {/* ====================================================
              BREADCRUMB
          ==================================================== */}
          <div className="pt-4 sm:pt-6">
            <div className="bg-white rounded-xl px-3 sm:px-5 py-3 border border-amber-100/60 overflow-hidden">
              <Breadcrumb
                separator=">"
                items={[
                  {
                    title: "Home",
                    href: "/",
                  },
                  {
                    title: "Products",
                    href: "/product",
                  },
                  {
                    title:
                      currItem?.name || "Product Details",
                  },
                ]}
              />
            </div>
          </div>

          {/* ====================================================
              PRODUCT MAIN CARD
          ==================================================== */}
          <div className="bg-white rounded-2xl shadow-sm border border-amber-100/60 mt-4 sm:mt-6 overflow-hidden">

            <div className="p-4 sm:p-6 md:p-8 lg:p-10">

              {/* ==================================================
                  PRODUCT GRID
              ================================================== */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14">

                {/* =================================================
                    LEFT - PRODUCT IMAGE
                ================================================= */}
                <div className="w-full">

                  <div className="flex flex-col gap-3">

                    {/* ================= MAIN IMAGE ================= */}
                    <div className="relative w-full">
                      {/* Main Image */}
                      <div
                        className=" relative w-full h-[340px] md:h-[420px] border border-amber-100 rounded-2xl bg-gradient-to-b from-[#FFFDF9] to-white flex items-center justify-center p-6 overflow-hidden cursor-crosshair "
                        onMouseEnter={() => setIsImageHovered(true)}
                        onMouseLeave={() => setIsImageHovered(false)}
                        onMouseMove={handleImageMouseMove}
                      >
                        {/* Discount Badge */}
                        {selectedDiscount > 0 && (
                          <div className="absolute top-4 left-4 z-20 bg-gradient-to-r from-amber-600 to-amber-500 text-white font-bold text-xs py-1 px-3.5 rounded-full shadow-md">
                            {selectedDiscount}% OFF
                          </div>
                        )}

                        <img
                          src={imageSrc}
                          alt={currItem?.name || "Product"}
                          className="
        max-h-[300px]
        md:max-h-[360px]
        max-w-full
        object-contain
        drop-shadow-md
        select-none
        pointer-events-none
      "
                          draggable={false}
                        />

                        {/* Zoom Lens Indicator */}
                        {isImageHovered && (
                          <div
                            className=" hidden md:block absolute pointer-events-none w-[120px] h-[120px] border-2 border-[#A17A17] bg-white/20 rounded-lg"
                            style={{
                              left: `${zoomPosition.x}%`,
                              top: `${zoomPosition.y}%`,
                              transform: "translate(-50%, -50%)",
                            }}
                          />
                        )}
                      </div>

                      {/* Zoomed Image */}
                      {isImageHovered && (
                        <div
                          className=" hidden md:block absolute left-[calc(100%+20px)] top-0 w-[450px] h-[420px] z-50 rounded-2xl border border-amber-200 bg-white shadow-2xl overflow-hidden"
                        >
                          <div
                            className="w-full h-full bg-no-repeat"
                            style={{
                              backgroundImage: `url(${imageSrc})`,
                              backgroundSize: "200%",
                              backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
                            }}
                          />
                        </div>
                      )}
                    </div>

                    {/* ================= THUMBNAILS ================= */}
                    <div className="flex items-center justify-center gap-2 sm:gap-3 overflow-x-auto pb-1">

                      {[1, 2, 3, 4].map((_, i) => (
                        <button
                          key={i}
                          type="button"
                          className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 border-2 border-amber-200 hover:border-[#A17A17] rounded-xl flex items-center justify-center p-1.5 bg-amber-50/20 transition-all"
                        >
                          <img
                            src={imageSrc}
                            alt={`Product thumbnail ${i + 1}`}
                            className="max-h-full max-w-full object-contain"
                          />
                        </button>
                      ))}

                    </div>
                  </div>
                </div>

                {/* =================================================
                    RIGHT - PRODUCT INFORMATION
                ================================================= */}
                <div className="flex flex-col">

                  {/* PRODUCT NAME */}
                  <div>
                    <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight break-words">
                      {currItem?.name || "Product"}
                    </h1>
                  </div>

                  {/* PRICE */}
                  <div className="mt-4 sm:mt-5">

                    <div className="flex flex-wrap items-center gap-2 sm:gap-3">

                      {selectedProductMrp >
                        selectedProductPrice && (
                          <span className="line-through text-gray-400 text-sm sm:text-base">
                            INR {selectedProductMrp}
                          </span>
                        )}

                      <span className="text-2xl sm:text-3xl font-black text-[#A17A17]">
                        INR{" "}
                        {selectedProductPrice ||
                          selectedProductMrp ||
                          0}
                      </span>

                    </div>

                    <div className="mt-2 inline-flex text-[10px] sm:text-xs text-green-700 bg-green-50 px-2 py-1 rounded-md font-medium">
                      Inclusive of all taxes
                    </div>
                  </div>

                  <hr className="my-5 sm:my-6 border-gray-100" />

                  {/* =================================================
                      PACKAGE SIZE
                  ================================================= */}
                  <div>

                    <p className="text-xs sm:text-sm uppercase font-semibold tracking-wider text-gray-500 mb-3">
                      Select Package Size
                    </p>

                    <div className="flex flex-wrap gap-2.5">

                      {currItem?.productPackageDetails?.map(
                        (size, idx) => {

                          const isSelected =
                            (selectedSize === size ||
                              (selectedSize?.packageSize &&
                                selectedSize.packageSize ===
                                size.packageSize)) &&
                            currIdx === idx;

                          return (
                            <button
                              key={idx}
                              type="button"
                              onClick={() =>
                                handleSize(size, idx)
                              }
                              className={`min-w-[80px] sm:min-w-[90px] px-4 py-2.5 rounded-xl text-xs sm:text-sm font-semibold transition-all ${isSelected
                                ? "bg-[#A17A17] text-white shadow-md border-2 border-[#A17A17]"
                                : "bg-[#FAF3E0]/70 text-gray-700 hover:bg-[#FAF3E0] border-2 border-amber-200/80"
                                }`}
                            >
                              {size.packageSize}
                            </button>
                          );
                        }
                      )}

                    </div>
                  </div>

                  {/* =================================================
                      CART ACTIONS
                  ================================================= */}
                  <div className="mt-7 sm:mt-8">

                    {cartQuantity === 0 ? (

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">

                        <button
                          type="button"
                          onClick={handleAddToCart}
                          className="w-full min-h-12 px-4 rounded-xl bg-gradient-to-r from-[#A17A17] to-[#B88E28] hover:from-[#8C6913] hover:to-[#A17A17] text-white text-sm sm:text-base font-bold shadow-md flex items-center justify-center gap-2 transition-all active:scale-[0.98]"
                        >
                          <ShoppingCartOutlined />
                          Add To Cart
                        </button>

                        <button
                          type="button"
                          onClick={handleBuyNow}
                          className="w-full min-h-12 px-4 rounded-xl border-2 border-[#A17A17] text-[#A17A17] hover:bg-[#FAF3E0] text-sm sm:text-base font-bold flex items-center justify-center transition-all active:scale-[0.98]"
                        >
                          Buy Now
                        </button>

                      </div>

                    ) : (

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">

                        {/* QUANTITY */}
                        <div className="w-full min-h-12 bg-[#FFF8E7] border-2 border-[#A17A17] rounded-xl flex items-center justify-between px-3">

                          <button
                            type="button"
                            onClick={handleDecrement}
                            className="w-9 h-9 rounded-lg bg-[#A17A17] hover:bg-[#8C6913] text-white flex items-center justify-center active:scale-90"
                            title={
                              cartQuantity === 1
                                ? "Remove from cart"
                                : "Decrease quantity"
                            }
                          >
                            {cartQuantity === 1 ? (
                              <DeleteOutlined />
                            ) : (
                              <MinusOutlined />
                            )}
                          </button>

                          <div className="flex flex-col items-center">
                            <span className="text-lg font-black text-[#4C3000] leading-none">
                              {cartQuantity}
                            </span>

                            <span className="text-[10px] text-amber-900 font-semibold mt-1">
                              in cart
                            </span>
                          </div>

                          <button
                            type="button"
                            onClick={handleIncrement}
                            className="w-9 h-9 rounded-lg bg-[#A17A17] hover:bg-[#8C6913] text-white flex items-center justify-center active:scale-90"
                          >
                            <PlusOutlined />
                          </button>

                        </div>

                        {/* GO CART */}
                        <button
                          type="button"
                          onClick={() =>
                            navigate("/cart")
                          }
                          className="w-full min-h-12 rounded-xl bg-[#A17A17] hover:bg-[#8C6913] text-white text-sm sm:text-base font-bold flex items-center justify-center gap-2"
                        >
                          Go to Cart
                          <CheckCircleFilled className="text-amber-200" />
                        </button>

                      </div>
                    )}

                  </div>

                  {/* =================================================
                      DELIVERY CHECKER
                  ================================================= */}
                  <div className="mt-7 sm:mt-8 p-4 sm:p-5 bg-amber-50/40 rounded-xl border border-amber-100">

                    <div className="flex gap-2 items-center text-gray-700 font-medium mb-3">

                      <TbTruckDelivery className="text-xl sm:text-2xl text-[#A17A17] flex-shrink-0" />

                      <span className="text-xs sm:text-sm uppercase tracking-wider font-bold text-gray-600">
                        Check Delivery Availability
                      </span>

                    </div>

                    <div className="flex flex-col sm:flex-row gap-2">

                      <Input
                        value={deliveryPin}
                        onChange={(e) =>
                          setDeliveryPin(
                            e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 6)
                          )
                        }
                        inputMode="numeric"
                        maxLength={6}
                        className="rounded-lg h-11 w-full"
                        placeholder="Enter 6-digit pin code"
                      />

                      <button
                        type="button"
                        className="h-11 w-full sm:w-auto px-6 bg-[#A17A17] hover:bg-[#8C6913] text-white text-sm font-semibold rounded-lg transition-colors"
                      >
                        Check
                      </button>

                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* ======================================================
              PRODUCT INFORMATION
          ====================================================== */}
          <div className="mt-5 sm:mt-8 mb-8 sm:mb-12 bg-white rounded-2xl shadow-sm border border-amber-100/60 overflow-hidden">

            {/* ====================================================
                TABS
            ==================================================== */}
            <div className="bg-[#FFF8E7] border-b border-amber-200/60">

              <div className="flex overflow-x-auto scrollbar-hide">

                {[
                  {
                    key: "description",
                    label: "DESCRIPTION",
                  },
                  {
                    key: "howtouse",
                    label: "HOW TO USE",
                  },
                  {
                    key: "ingredients",
                    label: "INGREDIENTS",
                  },
                  {
                    key: "benefits",
                    label: "BENEFITS",
                  },
                ].map((tab) => (

                  <button
                    key={tab.key}
                    type="button"
                    onClick={() =>
                      handleTabClick(tab.key)
                    }
                    className={`flex-shrink-0 py-3 px-4 sm:px-6 text-xs sm:text-sm md:text-base font-bold transition-all ${activeTab === tab.key
                      ? "text-[#A17A17] bg-white shadow-sm"
                      : "text-gray-600 hover:text-[#A17A17]"
                      }`}
                  >
                    {tab.label}
                  </button>

                ))}

              </div>

            </div>

            {/* ====================================================
                TAB CONTENT
            ==================================================== */}
            <div className="p-4 sm:p-6 md:p-8">

              {/* DESCRIPTION */}
              {activeTab === "description" && (
                <div>

                  <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-3">
                    Product Overview
                  </h3>

                  <p className="text-sm sm:text-base text-gray-600 leading-7 whitespace-pre-line break-words">
                    {currItem?.description ||
                      "No description provided for this product."}
                  </p>

                </div>
              )}

              {/* HOW TO USE */}
              {activeTab === "howtouse" && (
                <div>

                  <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-3">
                    Usage Instructions
                  </h3>

                  {currItem?.productToUse &&
                    currItem.productToUse.length > 0 ? (

                    <ul className="list-disc list-inside space-y-3 text-sm sm:text-base text-gray-600">

                      {currItem.productToUse.map(
                        (item, i) => (
                          <li
                            key={i}
                            className="leading-6"
                          >
                            {item.description}
                          </li>
                        )
                      )}

                    </ul>

                  ) : (

                    <p className="text-sm sm:text-base text-gray-500">
                      As directed by your Ayurvedic physician.
                    </p>

                  )}

                </div>
              )}

              {/* INGREDIENTS */}
              {activeTab === "ingredients" && (
                <div>

                  <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-3">
                    Key Ingredients
                  </h3>

                  {currItem?.productIngredients &&
                    currItem.productIngredients.length > 0 ? (

                    <div className="">

                      {currItem.productIngredients.map(
                        (item, i) => (

                          <div
                            key={i}
                            className="p-1 sm:p-2 rounded-xl font-medium text-sm sm:text-base text-gray-800 break-words"
                          >
                            {item.ingredientName}
                          </div>

                        )
                      )}

                    </div>

                  ) : (

                    <p className="text-sm sm:text-base text-gray-500">
                      Authentic herbs formulated according to traditional texts.
                    </p>

                  )}

                </div>
              )}

              {/* BENEFITS */}
              {activeTab === "benefits" && (
                <div>

                  <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-3">
                    Health Benefits
                  </h3>

                  {currItem?.productBenfits &&
                    currItem.productBenfits.length > 0 ? (

                    <ul className="list-disc list-inside space-y-3 text-sm sm:text-base text-gray-600">

                      {currItem.productBenfits.map(
                        (item, i) => (

                          <li
                            key={i}
                            className="leading-6"
                          >
                            {item.benfitDetails}
                          </li>

                        )
                      )}

                    </ul>

                  ) : (

                    <p className="text-sm sm:text-base text-gray-500">
                      Promotes holistic wellness and balance.
                    </p>

                  )}

                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
}

export default Productdetail;